import React, { ComponentProps, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ContentMessage from '../../../_lib/components/ContentMessage/ContentMessage';
import { Namespace } from '../../../translation/namespace';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { useRefreshBlock } from '../../../_lib/BlockFetcher';
import { CheckBoxParam, Form, SonForm, SubmitButton, useForm } from '../../../_lib/Form2';
import { SortableContentList } from '../../../_lib/components/SortableContentList';
import { DraggableAppLibraryPersonalListItem } from '../partials/AppLibraryPersonalListItem';
import IForm from '../../../types/IForm';
import ScrollArea from '../../../components/atoms/ScrollArea/ScrollArea';

type AppLibraryPersonalEditViewProps = {
  editForm: SonForm<CheckBoxParam<'selectedItems'>>;
  updateOrderForm: IForm;
};

function AppLibraryPersonalEdit({ editForm, updateOrderForm }: AppLibraryPersonalEditViewProps) {
  const { t } = useTranslation(Namespace.AppLibraryPersonal);
  const { delayedRefresh } = useRefreshBlock();
  const { formProps, fetchState, params } = useForm({
    form: editForm,
  });

  useEffect(() => {
    if (fetchState.type === 'success') {
      return delayedRefresh();
    }
  }, [delayedRefresh, fetchState.type]);

  const items = params.getAllByName('selectedItems').map((item) => {
    return { ...item, id: item.value };
  });

  return (
    <div className="app-library-personal">
      <ScrollArea to={100} bottomOffset={10}>
        <div className="app-library-personal__container">
          <ContentMessage modifier="padding-bottom" text={t('optionalEditInfo')} />
          <Form id="app-library-personal-form" modifier="no-padding" {...formProps}>
            <div className="app-library-personal__list-container">
              <SortableContentList items={items} form={updateOrderForm} hasDarkDragLayerBackground>
                {item =>
                  <DraggableAppLibraryPersonalListItem key={item.id} modifier="no-padding-vertical" {...item} />}
              </SortableContentList>
            </div>
            <SubmitButton
              buttonLabel={t('saveButton')}
              messageFail={t('status.fail')}
              messageSuccess={t('status.success')}
              messageSending={t('status.sending')}
              fetchState={fetchState}
            />
          </Form>
        </div>
      </ScrollArea>
    </div>
  );
}

export const AppLibraryPersonalEditView = asFetchableView(AppLibraryPersonalEdit);
export type AppLibraryPersonalEditView = ComponentProps<typeof AppLibraryPersonalEditView>;
